import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import axios from "axios";
import BusinessJpeg from "../../assets/images/business.jpeg";
import LogoSvg from "../../assets/images/logo.svg";
import EyeSvg from "../../assets/images/eye.svg";

import copy from "../../assets/images/copyright.svg";
import { getGlobalVar } from "../config/Config";
// import { loginWithCredentials } from './Auth';
/* import "./login.css"; */
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
const LoginPage = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  /* useEffect(() => {
    const fetchUser = async () => {
      try {
        const userInfo = await getUserInfo();
        setUser(userInfo);
        if (userInfo) {
          navigate("/dashboard");
        }
      } catch (err) {
        setError("Failed to fetch user data");
      }
    };

    fetchUser();
  }, []);*/
  const [globalVar, setValue] = React.useState(getGlobalVar());

  const [isSignUp, setIsSignUp] = useState(false);
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  // const response = await axios.post(globalVar.url+'/api/login/', {
  //     username,
  //     password
  // }, {
  //     headers: {
  //         'Content-Type': 'application/json'
  //     }
  // });

  /* sso handleLogin */
  const handleLogin = async () => {
    console.log(process.env.REACT_APP_SANDBOX);

    if (process.env.REACT_APP_SANDBOX === "true") {
      navigate("/dashboard");
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/check-auth/`,
          {
            withCredentials: true,
          },
        );

        const data = response.data;

        if (response.status === 200 && data.is_authenticated) {
          localStorage.setItem("auth", JSON.stringify(data));
          // setAuthChecked(true);
          navigate("/dashboard");
        } else {
          window.location.href = `${process.env.REACT_APP_BASE_URL}?next=${window.location.origin}/`;
          // redirect if not authenticated
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        window.location.href = `${process.env.REACT_APP_BASE_URL}?next=${window.location.origin}/`;
      }
    }
  };

  return (
    <div className="row main h-100  g-0 ">
      {/* Left side form */}
      <div className="col-md-6 bg-white p-0 mt-5 mt-md-0 d-flex justify-content-center align-items-center ">
        <div className="row p-5">
          <div className="col-md-6 mb-3">
            <button
              onClick={() => setIsSignUp(false)}
              className={`buttons py-2 px-4 ${
                !isSignUp ? "button-primary" : "button-secondary"
              } `}
            >
              Sign In
            </button>
          </div>

          <div className="col-md-6 mb-3">
            <a href="https://proerp.defconinnovations.com/register">
              <button
                className={`buttons py-2 px-4 ${
                  isSignUp ? "button-primary" : "button-secondary"
                }`}
              >
                Sign Up
              </button>
            </a>
          </div>
          <div>
            <h2 className="text-lg font-bold mt-4">Sign in to your account</h2>
            <div className="mt-4 space-y-4">
              <div className="col-12 mb-5 mt-2">
                <button
                  type="button"
                  onClick={handleLogin}
                  className="btn buttons db bbutton"
                >
                  <span>Sign In With SSO</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side Background Image Section */}
      <div
        className="col-md-6 p-0 d-none d-md-block position-relative "
        style={{
          height: "100vh",
          background: `url(${BusinessJpeg}) center/cover no-repeat`,
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100 
   d-flex flex-column justify-content-between align-items-center pb-4"
          style={{
            background:
              "linear-gradient(45deg, #6510e099,rgba(50, 8, 88, 0.4))",
          }}
        >
          {/* Main Logo Section */}
          <div className=" text-center m-auto">
            <img
              src={LogoSvg}
              alt="Pro CRM Logo"
              className="mb-3 pro"
              style={{
                width: "160px",
                height: "auto",
                justifyContent: "center",
                background: "none",
              }}
            />
          </div>

          {/* Copyright Section */}
          <div
            className="small-logo-text d-flex align-items-center w-100 px-4"
            style={{ maxWidth: "400px" }}
          >
            <img
              src={LogoSvg}
              alt="Small Logo"
              className="buss"
              style={{ width: "40px", height: "auto" }}
            />
            <div className="text-start ms-3">
              <p className="text-light fw-bold title mb-1">
                The{" "}
                <span className="prodigyTec text-warning">
                  Defcon Innovations
                </span>{" "}
                product
              </p>
              <p className="copy mb-0 small text-white-50">
                <img src={copy} className="c me-1" style={{ width: "20px" }} />
                Defcon Innovations Pvt. Ltd. All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
